import { render, staticRenderFns } from "./AssociationsTable.vue?vue&type=template&id=cd860610&scoped=true&lang=pug&"
import script from "./AssociationsTable.vue?vue&type=script&lang=js&"
export * from "./AssociationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AssociationsTable.vue?vue&type=style&index=0&id=cd860610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd860610",
  null
  
)

export default component.exports